import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  Bons,
  listCheques,
  updateCheque,
  Virements,
} from "../../../_App/Redux/Slices/payments/PaymentSlice";
import { useEffect, useState } from "react";
import flatpickr from "flatpickr";
import { ChequeType } from "../../../_App/Types/Entites/PaymentType";
import { formatdate } from "../../../_App/Helpers/helpers";
import { useTranslation } from "react-i18next";
import { SelectedOrganisationId } from "../../../_App/Redux/Slices/Auth/authSlice";
import Swal from "sweetalert2";
import TicketDeCaissePaid from "../TicketDeCaisse/TicketDeCaissePaid";

const BonsTables = () => {
  const dispatch = useAppDispatch();
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const navigate = useNavigate();

  const cheques = useAppSelector(Bons);
  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const [selectedDate, setSelectedDate] = useState<string | null>(null);

  const [stateShow, setStateShow] = useState(false);
  const [show, setShow] = useState("");
  const [status, setStatus] = useState("all");

  const open = () => {
    if (show !== "show") {
      setShow("show");
      setStateShow(true);
    } else {
      setShow("");
      setStateShow(false);
    }
  };

  useEffect(() => {
    const datepickerElement = document.getElementById(
      "datepicker"
    ) as HTMLInputElement;

    if (datepickerElement) {
      const flatpickrInstance = flatpickr(datepickerElement, {
        dateFormat: "Y-m-d",
        onChange: function (selectedDates, dateString) {
          setSelectedDate(dateString);
        },
      });
    }
  }, [dispatch, currentOrganisation]);

  const [ordersFilter, setOrdersFilter] = useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Form submitted with filter:", ordersFilter);
  };
  const filteringOrders = (item: any) => {
    if (item) {
      const filterLowerCase = ordersFilter.toLowerCase();
      const searchFilter =
        ordersFilter && item.numero.toLowerCase().includes(filterLowerCase);
      // Apply date filter only if a date is selected
      const dateFilter =
        !selectedDate || formatdate(item.date).toString() === selectedDate;

      return (
        dateFilter && // Only apply date filtering if selectedDate exists
        (ordersFilter === "" || searchFilter)
      );
    }
    return true;
  };

  const { t } = useTranslation();

  const handlePayCheque = async (data: any) => {
    console.log(JSON.stringify(data));
    Swal.fire({
      title: "Voulez vous vraiment payer ce chèque ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(updateCheque(data));
      }
    });
  };

  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(undefined);

  const handleOpenTicket = async (item: ChequeType) => {
    setSelectedOrder(item?.payment_id?.order_id);
    setShowModal(true);
  };

  useEffect(() => {
    if (!showModal) setSelectedOrder(undefined);
  }, [showModal]);

  return (
    <>
      <TicketDeCaissePaid
        ShowModal={showModal}
        setShowModal={setShowModal}
        order_id={selectedOrder}
      />
      <div className="row layout-spacing">
        <div className="col-lg-12">
          <div className="statbox widget box box-shadow">
            <div className="navbar-item flex-row search-ul navbar-dropdown">
              <div className="nav-item align-self-center search-animated">
                <i className="fas fa-search"></i>
                <form
                  className="form-inline search-full form-inline search"
                  role="search"
                  onSubmit={handleSubmit}
                >
                  <div className="search-bar">
                    <input
                      style={{ background: "#f1f2f3", border: "none" }}
                      type="text"
                      className="form-control search-form-control ml-lg-auto"
                      placeholder={t("search")}
                      autoFocus
                      onChange={(e) => setOrdersFilter(e.target.value)}
                    />
                  </div>
                </form>
              </div>
              <input
                type="text"
                className="form-control"
                style={{
                  background: "#f1f2f3",
                  border: "none",
                  width: "auto",
                  height: "auto",
                }}
                id="datepicker"
                value={t("Date") + ": " + selectedDate}
                onChange={(e) => setSelectedDate(e.currentTarget.value)}
              />{" "}
            </div>

            <div
              className="widget-content widget-content-area"
              style={{ overflowX: "auto" }}
            >
              <table id="style-2" className="table style-2  table-hover">
                <thead>
                  <tr>
                    <th
                      className="checkbox-column dt-no-sorting"
                      style={{ fontSize: "15px" }}
                    >
                      {t("Code")}
                    </th>
                    <th style={{ fontSize: "15px" }}>{t("Montant")}</th>
                    <th style={{ fontSize: "15px" }}>{t("Date")}</th>
                    <th style={{ fontSize: "15px" }}>{t("Date d'écheance")}</th>
                    <th style={{ fontSize: "15px" }}>{t("Valide")}</th>
                    <th style={{ fontSize: "15px" }}>{t("Type")}</th>
                  </tr>
                </thead>
                <tbody>
                  {cheques && cheques.length
                    ? cheques.map((item, index) => {
                        if (filteringOrders(item)) {
                          return (
                            <tr key={index}>
                              <td
                                className="checkbox-column"
                                style={{ fontSize: "15px" }}
                              >
                                {item.code}
                              </td>

                              <td style={{ fontSize: "15px" }}>
                                {item.amount + " TND"}
                              </td>
                              <td style={{ fontSize: "15px" }}>
                                {item.date.toString().split("T")[0]}
                              </td>
                              <td style={{ fontSize: "15px" }}>
                                {item.date.toString().split("T")[0]}
                              </td>
                              <td style={{ fontSize: "15px" }}>
                                {item.dateEcheance.toString().split("T")}
                              </td>
                              <td style={{ fontSize: "15px" }}>
                                {item.amount + " TND"}
                              </td>
                            </tr>
                          );
                        } else return null;
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BonsTables;
